import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useSubscription} from '../hooks/useSubscription';
import {Subscription} from '../types';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = useSubscription();

    return (
        <FormDrawer
            record={{
                id: '',
                customerId: '',
                startDate: 0,
                created: 0,
            } as Subscription}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
